import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import MenuDesktop from './MenuDesktop';
import MenuMobile from './MenuMobile';

import {
  toggleMenu,
  getLayoutData,
} from 'cityads-v3/actions/menu';

@withRouter
@connect(state => ({
  isLoggedIn: state.auth.isLoggedIn,
  isAuthChecked: state.menu.isAuthChecked,
  isLoadingLayoutData: state.menu.isLoading,
  isLayoutDataLoaded: state.menu.isLoaded,
  isLayoutDataFailed: state.menu.isFailed,
  isVisible: state.menu.isVisible,
  language: state.language.language,
  isMobile: state.app.isMobile
}))
export default class LeftMenu extends Component {

  static propTypes = {
    isLoggedIn: PropTypes.bool,
    isAuthChecked: PropTypes.bool,
    isLoadingLayoutData: PropTypes.bool,
    isLayoutDataLoaded: PropTypes.bool,
    isLayoutDataFailed: PropTypes.bool,
    language: PropTypes.string,
    isMobile: PropTypes.bool,
    isVisible: PropTypes.bool,
  }

  UNSAFE_componentWillMount() {
    this.checkShowMenu();

    const { isAuthChecked, isLoggedIn, isLoadingLayoutData, isLayoutDataLoaded, isLayoutDataFailed } = this.props;

    if (
      isAuthChecked &&
      isLoggedIn &&
      !isLayoutDataLoaded &&
      !isLoadingLayoutData &&
      (navigator || !isLayoutDataFailed)
    ) {
      this.getLayoutData();
    }
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const { isAuthChecked, isLoggedIn, isMobile, language } = newProps;

    if (
      (this.props.isAuthChecked !== isAuthChecked || this.props.language !== language) &&
      isAuthChecked &&
      isLoggedIn
    ) {
      this.getLayoutData();
    }

    if (this.props.isAuthChecked !== isAuthChecked || this.props.isMobile !== isMobile) {
      this.checkShowMenu(newProps);
    }
  }

  getLayoutData() {
    this.props.dispatch(getLayoutData());
  }

  toggleMenu(set = true, docked) {
    this.props.dispatch(toggleMenu(set, docked));
  }

  checkShowMenu(props = this.props) {
    const { opened, docked, isLoggedIn, isMobile, isAuthChecked } = props;

    if (isMobile){
      this.toggleMenu(false, false);
    } else {

      if (isAuthChecked) {
        if (
          !isLoggedIn ||
          (opened && !docked)
        ) {
          this.toggleMenu(false, false);
        }
      }

    }
  }

  render() {
    const { isMobile, isLoggedIn, isVisible } = this.props;

    if ((!isMobile && !isLoggedIn) || !isVisible) {
      return false;
    }

    return isMobile ? <MenuMobile/> : <MenuDesktop/>;
  }

}
